export default __webpack_public_path__ + "static/media/home-decor.ec30f2ee.png";